import { Helmet } from 'react-helmet-async';
import { SITE } from '../data/site';

export function breadcrumbLd(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.label,
      item: `${SITE.url}${it.href}`,
    })),
  };
}

export function orgLd() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE.name,
    url: SITE.url,
    email: SITE.email,
    telephone: `+1-${SITE.phone}`,
    description:
      'ToxGlobal Analytics supplies, installs, and supports analytical instrumentation for government and regulated laboratories nationwide — procurement, installation, commissioning, validation support, and lifecycle support.',
    address: { '@type': 'PostalAddress', addressCountry: 'US' },
    identifier: [
      { '@type': 'PropertyValue', name: 'UEI', value: SITE.uei },
      { '@type': 'PropertyValue', name: 'CAGE', value: SITE.cage },
    ],
  };
}

/**
 * Seo — per-page head management (title, meta, canonical, OG, Twitter, JSON-LD).
 * ld: array of schema.org objects. breadcrumbs: [{label, href}].
 */
export function Seo({ title, description, path = '/', ld = [], breadcrumbs = null }) {
  const canonical = `${SITE.url}${path}`;
  const allLd = [orgLd(), ...ld];
  if (breadcrumbs) allLd.push(breadcrumbLd(breadcrumbs));
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {allLd.map((obj, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(obj)}</script>
      ))}
    </Helmet>
  );
}
